const FlagEU = props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 17" className="flag-eu" {...props}>
		<path
			d="M22.6,0h-20c-1.1,0-2,0.9-2,2v13c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V2C24.6,0.9,23.7,0,22.6,0z M16.7,4.9
	l0.8,0.2l0.8-0.2l-0.2,0.8l0.2,0.8l-0.8-0.2l-0.8,0.2L17,5.7L16.7,4.9z M6.1,7.7l0.8,0.2l0.8-0.2L7.4,8.5l0.2,0.8L6.9,9.1L6.1,9.3
	l0.2-0.8L6.1,7.7z M8.5,12.1l-0.8-0.2l-0.8,0.2l0.2-0.8l-0.2-0.8l0.8,0.2l0.8-0.2l-0.2,0.8L8.5,12.1z M8.5,6.5L7.6,6.2L6.8,6.5
	l0.2-0.8L6.8,4.9l0.8,0.2l0.8-0.2L8.2,5.7L8.5,6.5z M10.5,14.2L9.7,14l-0.8,0.2l0.2-0.8l-0.2-0.8l0.8,0.2l0.8-0.2l-0.2,0.8
	L10.5,14.2z M10.5,4.4L9.7,4.2L8.9,4.4l0.2-0.8L8.9,2.8L9.7,3l0.8-0.2l-0.2,0.8L10.5,4.4z M13.4,15l-0.8-0.2L11.8,15l0.2-0.8
	l-0.2-0.8l0.8,0.2l0.8-0.2l-0.2,0.8L13.4,15z M13.4,3.6l-0.8-0.2l-0.8,0.2L12,2.8L11.8,2l0.8,0.2L13.4,2l-0.2,0.8L13.4,3.6z
	 M16.3,14.2L15.4,14l-0.8,0.2l0.2-0.8l-0.2-0.8l0.8,0.2l0.8-0.2L16,13.4L16.3,14.2z M16.3,4.4l-0.8-0.2l-0.8,0.2l0.2-0.8l-0.2-0.8
	L15.4,3l0.8-0.2L16,3.6L16.3,4.4z M18.3,12.1l-0.8-0.2l-0.8,0.2l0.2-0.8l-0.2-0.8l0.8,0.2l0.8-0.2l-0.2,0.8L18.3,12.1z M19.1,9.3
	l-0.8-0.2l-0.8,0.2l0.2-0.8l-0.2-0.8l0.8,0.2l0.8-0.2l-0.2,0.8L19.1,9.3z"
		/>
	</svg>
);

export default FlagEU;
